import { ISelectedPromotionInfoSchema } from '../../../repositories/billing-tariffs/entities/PublishTerms/SelectedPromotionInfoSchema';
import { ICheckServiceAuction } from '../types';

export function mapAuction(selectedPromotionInfo: ISelectedPromotionInfoSchema): ICheckServiceAuction {
  const { auctionBet, nextBets } = selectedPromotionInfo;

  const previousBets = selectedPromotionInfo.previousBets || [];

  return {
    currentBet: auctionBet,
    nextBets,
    // Бэк присылает предыдущие ставки в порядке убывания, но фронту нужны ставки в порядке возрастания: [...previousBets, currentBet, ...nextBets]
    // Вынести эту логику на сторону бэка бэки отказываются
    previousBets: previousBets.reverse(),
  };
}
